export default __webpack_public_path__ + "static/media/05_GIF.6ac2b9c2.gif";